import { render, staticRenderFns } from "./IconV2.vue?vue&type=template&id=24dc3977"
import script from "./IconV2.vue?vue&type=script&lang=js"
export * from "./IconV2.vue?vue&type=script&lang=js"
import style0 from "./IconV2.vue?vue&type=style&index=0&id=24dc3977&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports